import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import LabelWrapper from 'components/Common/LabelWrapper';
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { downloadImageNewsStockBulk } from 'store/thunks';

interface ModalDownloadBulkImageProps {
    isOpen: boolean;
    params: any;
    onClose: () => void;
}

const validateEmail = (email: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const ModalDownloadBulkImage = ({ isOpen = false, params = {}, onClose = () => { } }: ModalDownloadBulkImageProps) => {
    const { t, i18n } = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');

    const handleDownloadBulkImage = async () => {
        try {
            if (isLoading || !params) {
                return;
            }
            if (!validateEmail(email)) {
                toast(t("Email is invalid"), CONFIG_OPTION_TOAST_ERROR);
                return;
            }
            setIsLoading((_prev) => true);
            const response: any = await downloadImageNewsStockBulk({ ...params, email });
            setIsLoading((_prev) => false);
            if (response?.code === 200) {
                toast(t("The process has been completed."), CONFIG_OPTION_TOAST_NORMAL);
                handleClose();
                setEmail('');
            } else {
                toast(response?.message || response, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };


    const handleClose = () => {
        onClose();
    };

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                scrollable={false}
            >
                <ModalHeader toggle={handleClose}>
                    <>{t("Button Download Bulk Image")}</>
                </ModalHeader>
                <ModalBody className="pt-2">
                    <Row>
                        <Col md={12}>
                            <CardBody className="pt-0">
                                <Row>
                                    <Col sm={12} className='mt-3 mb-0'>
                                        <LabelWrapper label={t('Email') + ' (' + t('The results will be sent to Email') + ')'} isShow={true} isRequired={true} >
                                            <Input
                                                name="email"
                                                type="text"
                                                className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                placeholder=""
                                                value={email}
                                                onChange={(event: any) => {
                                                    const input = event.target.value;
                                                    setEmail(input);
                                                }}
                                                autoComplete="off"
                                            />
                                        </LabelWrapper>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center"></div>
                    <button
                        className="btn btn-primary mb-3 rounded-pill"
                        type="button"
                        onClick={handleDownloadBulkImage}
                        style={{ width: '200px' }}
                        disabled={isLoading || !email || !validateEmail(email)}
                    >
                        {isLoading ? <Spinner size="sm" className="me-2" ></Spinner> : <></>}
                        {t("Button Download Bulk Image")}
                    </button>
                </ModalFooter>
            </Modal>
        </React.Fragment >
    );
};

export default ModalDownloadBulkImage;